import * as types from "./actionTypes";

const initialState = {
  user: {},
  userInfo: {},
  userIsIdle: false,
};

export default function reduce(state = initialState, action = {}) {
  switch (action.type) {
    case types.SAVE_USER_ACTION:
      return {
        ...state,
        user: action.payload,
        userInfo: action.payload,
      };
    case types.SETTINGS_USER_UPDATED:
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload,
        },
      };
    case types.USER_ACTIVITY_ACTION:
      return {
        ...state,
        userIsIdle: action.payload,
      };

    case types.USER_LOGOUT:
      return initialState;

    default:
      return state;
  }
}
